exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".viewport[data-v-0fe7395b]{position:relative;min-height:50vh}.viewport canvas[data-v-0fe7395b],.viewport video[data-v-0fe7395b]{position:fixed;left:0;top:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0fe7395b","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./EcomCore/Components/InputDevices/QuaggaJsBarcodeScanner.vue
// module id = 56
// module chunks = 0